<template>
  <!-- 封面 -->  
      <div class="cover-page" >
        <div class="coverDiv"   :class="{ coverMoDiv: flag == 'app' }">
          <p class="addText">{{ coverData.psdz }}</p>
          <h1 class="title">{{ coverData.psmc }}</h1>
          <p class="zuzhi">{{ coverData.bzr }}</p>
          <p class="time">{{ coverData.bzsj }}</p>
          <p class="num">{{ coverData.jh }}</p>
        </div>
      </div>
</template>
    
<script>
export default {
  props: ['catalog','coverData'],
  data() {
    return {
      flag:'pc'
    }
  },
  mounted() {
    console.log(this.coverData,'----coverData')
    this.flag=sessionStorage.getItem("flag")
    console.log(this.flag,'----flag')

  },
  methods:{
  
  }
  
}
</script>
<style>
.cover-page{
  margin-top: 5px;
}
.coverDiv{
   width: 100%;
    height: 781px;
    padding: 50px 80px;
    background: #30849a;
    text-orientation: upright;
    letter-spacing: 0.2em;
    text-align: center;
    -webkit-writing-mode: vertical-rl;
    -moz-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    position: absolute;
}
.addText{
    font-size: 17px;
    font-weight: bold;
    writing-mode: vertical-rl;    /* 垂直排列，从右到左 */
    -webkit-writing-mode: vertical-rl; /* 兼容 WebKit 内核 */
    -moz-writing-mode: vertical-rl;    /* 兼容 Firefox */
    -ms-writing-mode: tb-rl;           /* 兼容 IE */
    position:absolute;
    right:65px;
}
.title{
    font-size: 75px;
    font-weight: bold;
    writing-mode: vertical-rl;    /* 垂直排列，从右到左 */
    -webkit-writing-mode: vertical-rl; /* 兼容 WebKit 内核 */
    -moz-writing-mode: vertical-rl;    /* 兼容 Firefox */
    -ms-writing-mode: tb-rl;           /* 兼容 IE */
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0;
    transform: translate(-50%, -50%); 
}
.zuzhi,.time{
  font-size: 16px;
  writing-mode: vertical-rl;    /* 垂直排列，从右到左 */
  -webkit-writing-mode: vertical-rl; /* 兼容 WebKit 内核 */
  -moz-writing-mode: vertical-rl;    /* 兼容 Firefox */
  -ms-writing-mode: tb-rl;           /* 兼容 IE */
  position:absolute;
  left:80px;
  top:50%; 
}
.zuzhi{
   left:110px; 
}
.num{
  font-size: 16px;
  position: absolute;
  left: 50%;
  bottom: 50px;
  -webkit-transform: translate(-50%, -50%);
  color:#51616b; 
  -webkit-writing-mode: initial;
}
.coverMoDiv{
  height:80% !important;
  padding: 10px !important;
  position: relative !important;
}
.coverMoDiv .addText{
  right: 20px !important;
    font-size: 1.1rem !important;
}
.coverMoDiv .title{
  font-size: 4rem !important;
}
.coverMoDiv .zuzhi{
  left:3rem !important;
}
.coverMoDiv .time{
  left: 1.5rem !important;
}
.coverMoDiv p ,.coverMoDiv h1 {
  color: #333 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/coverCom.vue